import { connect } from 'react-redux';
import ResourcesPage from 'components/Resources/Page';

const mapDispatchToProps = (dispatch, { match: { params } }) => ({
  isFaqPage: false,
  groupId: params.groupId,
  resourceId: params.resourceId,
});

export default connect(
  undefined,
  mapDispatchToProps,
)(ResourcesPage);
